import { render } from "./ProductsArchive.vue?vue&type=template&id=021f27ec&scoped=true"
import script from "./ProductsArchive.vue?vue&type=script&lang=js"
export * from "./ProductsArchive.vue?vue&type=script&lang=js"

import "./ProductsArchive.vue?vue&type=style&index=0&id=021f27ec&lang=scss&scoped=true"
import "./ProductsArchive.vue?vue&type=style&index=1&id=021f27ec&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021f27ec"]])

export default __exports__